import { createContext } from 'preact';
import { useReducer, useMemo } from 'preact/hooks';
import initialState from './state/index';
import rootReducer from './reducer/index';

function Store({ children }) {
  const [state, dispatch] = useReducer(rootReducer, initialState);
  const contextValue = useMemo(() => [state, dispatch], [state]);

  return (
    <Context.Provider value={contextValue}>
      { children }
    </Context.Provider>
  );
}

export const Context = createContext(initialState);

export default Store;
